<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- <div class="button-container"> -->
    <button
      :id="id"
      :type="type"
      :disabled="disabled"
      class="button"
      :class="variant"
      :aria-describedby="`${id}-help`"
      :aria-label="icon ? `${label} with ${getIconName(icon)} icon` : label"
      @click="$emit('click', $event)"
    >
      <i v-if="icon" class="button-icon" :class="icon"></i>
      <slot>{{ label }}</slot>
    </button>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "secondary"].includes(value),
    },
    PropName: {
      type: String,
      default: "Button",
    },
    icon: {
      type: String,
      default: null,
    },
  },
  emits: ["click"],
  methods: {
    getIconName(iconClasses) {
      if (!iconClasses) return "unknown";
      // Split the classes (e.g., "fa fa-plus") and get the last class
      const classes = iconClasses.split(/\s+/);
      // Find the class that starts with "fa-" (specific to Font Awesome icons)
      const iconClass = classes.find(cls => cls.startsWith("fa-"));
      if (!iconClass) return "unknown";
      // Remove "fa-" prefix and return the icon name (e.g., "plus", "trash", "edit")
      return iconClass.replace(/^fa-/, "").replace(/-/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 1rem;
  font-family: "Voyado Text";
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, opacity 0.2s;
  line-height: 1.5;
  gap: 0.5rem; /* Space between icon and label */
}

.button-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem; /* Match the button font size */
  line-height: 1;
}

.button.primary {
  background: #2D6E6D;
  border: none;
  color: #ffffff;
}

.button.primary:hover:not(:disabled) {
  background-color: #256b64;
  border-color: #d1d5db;
}

.button.secondary {
  background-color: #ffffff;
  border: 2px solid #E0E9E8;
  color: #2D6E6D;
}

.button.secondary:hover:not(:disabled) {
  background-color: #256b64;
  border: 2px solid #256b64;
  color: #ffffff;
}

.button:disabled {
  background-color: #e9ecef;
  border-color: #c0c0bc;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.button.p-invalid {
  border-color: #dc3545;
  background-color: #dc3545;
}

.button.p-invalid:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
}
.p-error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}
</style>